import { SelectItem } from '@diamond/shared/types';
import { Dropdown } from '@diamond/shared/ui';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import {
  getProductFilterRoute,
  getProductFilters,
} from './useProductFilters';

interface ItemSortByProps {
  sortsData: SelectItem[];
}

type FormProps = {
  sortby: string;
};

export const ItemSortBy: FC<ItemSortByProps> = ({ sortsData }) => {
  const { pathname, query, push } = useRouter();
  const filters = getProductFilters(query);
  const { register, handleSubmit } = useForm({
    defaultValues: {
      sortby: filters.sort_by_code,
    },
    values: {
      sortby: filters.sort_by_code,
    },
  });

  const submitHandler: SubmitHandler<FormProps> = ({
    sortby,
  }: {
    sortby: string | string[];
  }) => {
    const url = getProductFilterRoute(pathname, query, { sortby, page: 1 });
    push(url, undefined, { shallow: true });
  };

  return (
    <form
      onSubmit={handleSubmit(submitHandler)}
      onChange={handleSubmit(submitHandler)}
    >
      <Dropdown
        name="sortby"
        placeholder="Semua"
        size="md"
        items={sortsData}
        register={register}
      />
    </form>
  );
};
